import addresses from '../contractData/TypeIIChallenges/addresses.json';
const address = addresses['sepolia']
export default address 